<template>
  <v-app>
    <landing-navigation app/>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer color="primary" padless>
      <v-container fluid>
        <v-row justify="center" class="py-2">
          <v-col class="caption text-center white--text" cols="12" sm="6" md="4">
            By using this portal you agree to our
            <a href="https://api-nominations.kanuparty.org/terms.pdf" class="white--text font-weight-bold">Terms &amp; Conditions</a>
            and
            <a href="https://api-nominations.kanuparty.org/privacy.pdf" class="white--text font-weight-bold">Privacy Policy</a>
          </v-col>
          <v-col class="caption text-center white--text" cols="12" sm="6" md="4">
            <a href="https://api-nominations.kanuparty.org/rules.pdf" class="white--text font-weight-bold">
              <v-icon x-small color="white">mdi-file-document</v-icon> Nomination Rules
            </a>
          </v-col>
          <v-col class="caption text-center white--text" cols="12" sm="6" md="4">
            All Rights Reserved &copy; {{ new Date().getFullYear() }} — KANU Party
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import LandingNavigation from "../components/navigation/LandingNavigation";

export default {
  name: "LandingLayout",
  components: { LandingNavigation },
}
</script>

<style scoped>
</style>
